(() => {
  const publicKeys = ['Προπαραγγελία', 'Pre-order', 'Предварителна поръчка'];
  let pending = null;

  function candidates() {
    const lines = new Map();
    document.querySelectorAll('line-item[data-mine-preorder-stale="true"]').forEach((line) => {
      lines.set(line.dataset.mineLineKey, {
        key: line.dataset.mineLineKey,
        managed: line.dataset.mineInventoryManaged !== 'false',
        inventory: Number(line.dataset.mineInventoryQuantity)
      });
    });
    return Array.from(lines.values());
  }

  function clearedProperties(properties) {
    const result = { ...properties, _mine_preorder: 'false' };
    publicKeys.forEach((key) => delete result[key]);
    return result;
  }

  function covered(item, items, metadata) {
    if (!metadata.managed) return true;
    if (!Number.isFinite(metadata.inventory)) return false;
    const quantity = items.filter((line) => line.variant_id === item.variant_id)
      .reduce((sum, line) => sum + line.quantity, 0);
    return metadata.inventory >= quantity;
  }

  async function request(path, options) {
    const response = await fetch(window.Shopify.routes.root + path, {
      cache: 'no-store',
      ...options
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || 'Cart update failed');
    return data;
  }

  async function reconcile() {
    const stale = candidates();
    if (!stale.length) return;
    let changed = false;
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
    try {
      let current = await request('cart.js');
      for (const metadata of stale) {
        const item = current.items.find((line) => line.key === metadata.key);
        if (!item || String(item.properties?._mine_preorder) !== 'true' || !covered(item, current.items, metadata)) continue;
        current = await request('cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: item.key,
            quantity: item.quantity,
            properties: clearedProperties(item.properties || {})
          })
        });
        changed = true;
      }
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      if (changed) {
        if (window.themeVariables?.settings?.pageType === 'cart') {
          window.location.reload();
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      }
    }
  }

  function synchronize() {
    if (!pending) {
      pending = reconcile().catch(() => {}).finally(() => { pending = null; });
    }
    return pending;
  }

  document.addEventListener('cart-drawer:refreshed', synchronize);
  document.addEventListener('dialog:before-show', (event) => {
    if (event.target.id === 'cart-drawer' && !pending) {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', synchronize, { once: true });
  } else {
    synchronize();
  }
  window.addEventListener('pageshow', synchronize);
})();
